<template>
  <div class="flex flex-col min-h-screen">
    <Header />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex-1 bg-white p-2">
      <div
        class="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8 flex flex-col gap-5"
      >
        <div>
          <!-- Open Popup Button -->
          <div class="flex items-center justify-between mt-4">
            <div class="flex items-center gap-2">
              <h1 class="text-lg font-semibold text-slate-800">
                Notification Logs
              </h1>
              <span class="ml-2 text-sm font-normal text-gray-500">
                ({{ total_count || 0 }})
              </span>
              <span
                v-if="userSelectList.length > 0"
                class="ml-3 pl-3 border-l border-gray-200 text-sm font-medium text-indigo-600"
              >
                Selected: {{ userSelectList.length }}
              </span>
            </div>

            <button
              @click="showPopup = true"
              class="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-white bg-blues hover:bg-hover rounded-2xl shadow-sm transition-all duration-200"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Trigger Email
            </button>
          </div>
          <!-- Popup Modal -->
          <div
            v-if="showPopup"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
          >
            <div
              class="bg-white rounded-[2rem] shadow-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto relative"
            >
              <!-- Close Button -->

              <!-- Your Existing Code -->
              <div
                class="bg-white rounded-[2rem] border border-slate-200 shadow-sm overflow-hidden"
              >
                <div class="flex justify-between px-8 pt-4">
                  <div class="space-y-1">
                    <h1
                      class="text-lg font-semibold text-slate-800 tracking-tight"
                    >
                      {{ activeSchema?.title || "Email Trigger" }}
                    </h1>
                    <p class="text-[10px] font-medium text-slate-500">
                      Configure your dynamic template
                    </p>
                  </div>
                  <button
                    @click="
                      showPopup = false;
                      this.activeSchema = null;
                      selectedId = '';
                    "
                    title="Close"
                    class="w-7 h-7 flex items-center justify-center rounded-full bg-red-100 text-red-600 text-xl font-bold transition-all duration-200 hover:bg-red-600 hover:text-white shadow-sm"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2.5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M6 6l12 12M18 6L6 18"
                      />
                    </svg>
                  </button>
                </div>
                <div class="px-6 md:px-8 mb-6">
                  <div
                    class="flex flex-col md:flex-row md:items-center justify-end gap-4 mb-3"
                  >
                    <!-- Template Selector -->
                    <div class="relative min-w-[240px]">
                      <label
                        class="absolute -top-2 left-3 bg-white px-1 text-[10px] font-bold text-blue-600 uppercase"
                      >
                        Select Template
                      </label>

                      <select
                        v-model="selectedId"
                        @change="fetchSchema"
                        class="w-full text-sm bg-slate-50 border border-slate-300 rounded-2xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-blue-600"
                      >
                        <option value="">Choose a workflow...</option>

                        <option
                          v-for="t in templates"
                          :key="t.id"
                          :value="t.id"
                        >
                          {{ t.title.replace(/_/g, " ") }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Dynamic Form Area -->
                  <div
                    v-if="activeSchema"
                    class="bg-slate-50/50 rounded-3xl p-6 border border-slate-100"
                  >
                    <form @submit.prevent="submit" class="space-y-6">
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div
                          v-for="(field, index) in activeSchema.fields"
                          :key="index"
                          :class="field.type === 'Text' ? 'md:col-span-2' : ''"
                        >
                          <label
                            class="block text-xs font-medium text-slate-700 mb-2 px-1"
                          >
                            {{ field.label }}
                            <span v-if="field.required" class="text-red-500"
                              >*</span
                            >
                          </label>

                          <!-- Field Types -->
                          <input
                            v-if="field.type === 'List'"
                            v-model="form[field.label]"
                            required
                            placeholder="e.g. user1@mail.com"
                            pattern="^(\s*\S+@\S+\.\S+\s*)(,\s*\S+@\S+\.\S+\s*)*$"
                            title="Enter valid email addresses separated by commas"
                            class="w-full text-sm bg-white border border-slate-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                          />
                          <textarea
                            v-else-if="field.type === 'Text'"
                            v-model="form[field.label]"
                            required
                            rows="2"
                            placeholder="Enter content here..."
                            class="w-full text-sm bg-white border border-slate-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                          ></textarea>
                          <select
                            v-else-if="field.type === 'ForeignKey'"
                            v-model="form[field.label]"
                            required
                            class="w-full text-sm bg-white border border-slate-200 rounded-xl px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600 cursor-pointer text-slate-900"
                          >
                            <option value="">Select {{ field.label }}</option>
                            <option
                              v-for="opt in getOptions(field.model)"
                              :key="opt.id"
                              :value="opt.id"
                            >
                              {{ opt.name }}
                            </option>
                          </select>

                          <p
                            v-if="field.Reason"
                            class="flex items-center gap-1.5 text-[10px] font-medium text-slate-400 mt-2 px-1"
                          >
                            <svg
                              class="w-3 h-3 text-blue-400"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                clip-rule="evenodd"
                              />
                            </svg>
                            {{ field.Reason }}
                          </p>
                        </div>
                      </div>

                      <!-- Form Actions -->
                      <div
                        class="flex items-center justify-end gap-4 pt-4 border-t border-slate-200/60"
                      >
                        <div class="flex justify-end items-center gap-3">
                          <button
                            type="submit"
                            :disabled="disable_submit == true"
                            class="relative flex items-center gap-2 overflow-hidden px-4 py-2 rounded-2xl font-bold text-xs transition-all shadow-lg"
                            :class="
                              disable_submit == true
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                : 'bg-blues text-white hover:bg-hover hover:shadow-md'
                            "
                          >
                            Send
                          </button>
                          <img
                            v-if="disable_submit"
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                        </div>
                      </div>
                    </form>
                  </div>

                  <!-- Empty State -->
                  <div
                    v-else
                    class="py-12 text-center bg-slate-50/50 rounded-3xl border-2 border-dashed border-slate-200"
                  >
                    <p class="text-sm font-bold text-slate-400">
                      Please select a template to begin configuration
                    </p>
                  </div>
                </div>
              </div>
              <!-- End Existing Code -->
            </div>
          </div>
        </div>

        <div class="w-full space-y-2">
          <div class="mb-4">
            <div class="flex flex-wrap justify-end items-center gap-3">
              <div class="w-full md:max-w-40">
                <select
                  v-model="selected_sort"
                  @change="getEmail(1), getAllEmail()"
                  class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="">Sort By</option>
                  <option value="user__email">A → Z</option>
                  <option value="-user__email">Z → A</option>
                  <option value="created_at">Newest First</option>
                  <option value="-created_at">Oldest First</option>
                </select>
              </div>
              <!-- Filter -->
              <select
                v-model="selectfilter"
                @change="onFilterChange"
                class="min-w-[180px] rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled>Select Filter</option>
                <option v-for="t in templates" :key="t.id" :value="t.title">
                  {{ t.title.replace(/_/g, " ") }}
                </option>
              </select>

              <!-- Search -->
              <div class="relative w-full sm:w-[300px] md:w-[350px]">
                <input
                  type="text"
                  v-model="searching"
                  @input="
                    getEmail(1);
                    getAllEmail();
                  "
                  placeholder="Search by title, email or date..."
                  class="w-full rounded-xl border border-slate-300 bg-white px-4 py-2 pr-10 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <img
                  src="@/assets/search_icon1.svg"
                  alt="Search"
                  class="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 opacity-50"
                />
              </div>

              <!-- Clear -->
              <button
                @click="clearFilters"
                class="rounded-xl bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all"
              >
                Clear
              </button>

              <div v-if="this.userSelectList != 0">
                <button
                  class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm flex items-center justify-center hover:bg-hover transition-all duration-200"
                  @click="userdeownload"
                  :disabled="isDownload"
                >
                  <span v-if="!isDownload">Download</span>
                  <span v-else class="flex items-center gap-2">
                    <svg
                      class="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                      ></path>
                    </svg>
                    Download...
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 mb-4 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-textblues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>
          <div
            v-if="loading"
            class="py-20 text-center bg-white rounded-[2rem] border border-slate-200 shadow-sm flex flex-col items-center justify-center gap-3"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div v-else-if="this.email_list.length > 0" class="pb-20">
            <div
              class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
            >
              <table class="min-w-full text-[12px]">
                <thead class="bg-gray-100">
                  <tr>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      <input
                        type="checkbox"
                        v-model="selectAll"
                        @change="toggleSelectAll"
                        class="w-4 h-4 rounded text-blue-600 border-gray-400"
                      />
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      S.No
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      Student Info
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      Batch
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      PRN
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      Type
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      Subject
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      Message
                    </th>

                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      Status
                    </th>
                    <th
                      class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                    >
                      Created
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                  <tr
                    v-for="(el, index) in email_list"
                    :key="index"
                    class="hover:bg-gray-50 transition whitespace-nowrap"
                  >
                    <td class="py-3 px-4 border-r text-left">
                      <input
                        type="checkbox"
                        :value="el?.user?.id"
                        v-model="userSelectList"
                        class="w-4 h-4 rounded text-blue-600 border-gray-400"
                      />
                    </td>
                    <td class="py-3 px-4 border-r text-left">
                      {{ (currentPage - 1) * pageSize + index + 1 }}
                    </td>
                    <td class="py-3 px-4 border-r">
                      <div class="flex items-center gap-2">
                        <div
                          class="w-7 h-7 flex-shrink-0 rounded-full uppercase bg-indigo-50 flex items-center justify-center text-[10px] font-bold text-indigo-600"
                        >
                          {{ el?.user?.display_name.charAt(0) || "?" }}
                        </div>
                        <div class="flex flex-col min-w-0">
                          <span
                            class="text-xs font-semibold text-slate-700 uppercase"
                          >
                            {{ el?.user?.display_name || "NA" }}
                          </span>
                          <div
                            class="text-[12px] text-gray-500 flex items-center gap-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="12px"
                              viewBox="0 -960 960 960"
                              width="12px"
                              fill="#9CA3AF"
                            >
                              <path
                                d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                              />
                            </svg>
                            {{ el?.user?.email || "NA" }}
                          </div>
                          <div
                            class="text-xs text-gray-500 flex flex-wrap gap-x-3 gap-y-1 items-baseline"
                          >
                            <span class="whitespace-nowrap text-xs">
                              Program: {{ el?.user?.program || "NA" }}
                            </span>

                            <span class="whitespace-nowrap text-xs">
                              Semester:
                              {{ el?.semester?.semester || "NA" }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700"
                    >
                      {{ el?.user?.batch || "NA" }}
                    </td>
                    <td
                      class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700"
                    >
                      {{ el?.user?.prn_number || "NA" }}
                    </td>
                    <td class="py-3 px-4 border-r">
                      <div class="min-w-[220px] break-words whitespace-normal">
                        {{ (el.title || "NA").replace(/[^\w\s-]/g, "").trim() }}
                      </div>
                    </td>

                    <td class="py-3 px-4 border-r">
                      <div class="min-w-[220px] break-words whitespace-normal">
                        {{
                          (el.subject || "NA").replace(/[^\w\s-]/g, "").trim()
                        }}
                      </div>
                    </td>
                    <td
                      class="py-3 px-4 border-r text-left text-gray-700 font-medium max-w-sm"
                    >
                      <div class="flex justify-center">
                        <button
                          type="button"
                          v-if="el.message"
                          @click="openMessagePopup(el.message)"
                          class="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded-lg hover:bg-blue-100 transition shadow-sm text-xs font-medium"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                          View
                        </button>
                      </div>
                    </td>

                    <td class="py-3 px-4 text-left whitespace-nowrap">
                      <span
                        :class="[
                          'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold',
                          el.status === true
                            ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                            : 'bg-rose-50 text-rose-700 border border-rose-200',
                        ]"
                      >
                        <span
                          :class="[
                            'w-1.5 h-1.5 rounded-full',
                            el.status === true
                              ? 'bg-emerald-500'
                              : 'bg-rose-500',
                          ]"
                        ></span>
                        {{ el.status === true ? "Success" : "Failure" }}
                      </span>
                    </td>
                    <td
                      class="py-3 px-4 border-l text-left whitespace-nowrap text-gray-700"
                    >
                      {{ el.created_at ? formatDate(el.created_at) : "NA" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              v-if="totalPages > 1"
              class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
            >
              <!-- PAGE SIZE -->
              <div
                class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
              >
                <span class="flex md:hidden">Rows per page:</span>
                <select
                  v-model="pageSize"
                  @change="onPageSizeChange"
                  class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>

              <!-- PAGINATION -->
              <div class="flex justify-center">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="getEmail"
                />
              </div>
            </div>
          </div>
          <div
            v-else
            class="py-20 text-center bg-white rounded-[2rem] border border-dashed border-slate-200 shadow-sm"
          >
            <h3 class="text-slate-800 font-bold">No Data Found</h3>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showMessagePopup"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="bg-white rounded-lg shadow-lg w-[600px] max-w-[90%] p-6">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-lg font-semibold">Message</h2>

          <button
            @click="closeMessagePopup"
            class="text-gray-500 hover:text-red-500 text-xl"
          >
            ✕
          </button>
        </div>

        <div
          class="max-h-[500px] overflow-y-auto overflow-x-hidden break-words"
        >
          <iframe
            v-if="
              selectedMessage.includes('<html') ||
              selectedMessage.includes('<!doctype')
            "
            :srcdoc="selectedMessage"
            class="w-full h-[450px] border rounded"
          ></iframe>

          <div
            v-else
            v-html="selectedMessage"
            class="prose prose-sm max-w-none"
          ></div>
        </div>

        <div class="mt-6 text-right">
          <button
            @click="closeMessagePopup"
            class="bg-blues text-white px-4 py-2 rounded hover:bg-hover"
          >
            Close
          </button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";
import Footer from "@/components/Footer.vue";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      disable_submit: false,
      templates: [],
      selectedId: "",
      selectedTemplateTitle: "",
      activeSchema: null,
      form: {},
      selectedCourseId: null,
      selectedSectionId: null,
      selectedTeamId: null,
      disable_submit: false,
      mockOptions: {
        Course: [],
        Assignment: [],
        Section: [],
        Lesson: [],
        Calendar: [],
        Team: [],
        Project: [],
        CourseQuiz: [],
      },
      email_list: [],
      loading: true,
      currentPage: 1,
      totalPages: 1,
      selectfilter: "",
      searching: "",
      pageSize: 10,
      showPopup: false,
      total_count: "",
      selectAll: false,
      studentAllList: [],
      userSelectList: [],
      allEmaillist: [],
      isDownload: false,
      response_message: "",
      showMessagePopup: false,
      selectedMessage: "",
      selected_sort: "",
    };
  },
  components: {
    Header,
    FlashMessage,
    Pagination,
    Footer,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        if (val["Course Name"] !== this.selectedCourseId) {
          this.selectedCourseId = val["Course Name"] || null;

          this.selectedSectionId = null;
          this.form["Section Name"] = "";
          this.form["Lesson Name"] = "";
          this.form["Assignment Name"] = "";
          this.form["Live Class Name"] = "";
          this.form["Quiz Name"] = "";

          this.mockOptions.Section = [];
          this.mockOptions.Lesson = [];
          this.mockOptions.Assignment = [];
          this.mockOptions.Calendar = [];
          this.mockOptions.CourseQuiz = [];

          this.selectedTeamId = null;
          this.mockOptions.Team = [];
          this.mockOptions.Project = [];

          if (this.selectedCourseId) {
            this.fetchForeignKey("Assignment");
            this.fetchForeignKey("Section");
            this.fetchForeignKey("Calendar");
            this.fetchForeignKey("Team");
            this.fetchForeignKey("CourseQuiz");
          }
        }

        if (val["Section Name"] !== this.selectedSectionId) {
          this.selectedSectionId = val["Section Name"] || null;

          this.form["Lesson Name"] = "";
          this.mockOptions.Lesson = [];

          if (this.selectedCourseId && this.selectedSectionId) {
            this.fetchForeignKey("Lesson");
          }
        }
        if (val["Team Name"] !== this.selectedTeamId) {
          this.selectedTeamId = val["Team Name"] || null;

          this.form["Lesson Name"] = "";
          this.mockOptions.Project = [];

          if (this.selectedCourseId && this.selectedTeamId) {
            this.fetchForeignKey("Project");
          }
        }
      },
    },
    userSelectList(newVal) {
      if (!this.allEmaillist.length) return;

      const validIds = this.allEmaillist.map((x) => x.user.id);

      const filtered = newVal.filter((id) => validIds.includes(id));

      if (filtered.length !== newVal.length) {
        this.userSelectList = filtered;
        return;
      }

      this.selectAll =
        filtered.length > 0 && filtered.length === this.allEmaillist.length;
    },
  },

  created() {
    this.fetchTemplates();
    this.getAllEmail();
    this.getEmail(1);
  },
  mounted() {},
  methods: {
    async onFilterChange() {
      // Clear selected checkboxes
      this.userSelectList = [];
      this.selectAll = false;

      if (this.selectfilter) {
        await this.getAllEmail();
      }

      await this.getEmail(1);
    },
    openMessagePopup(message) {
      if (!message) {
        this.selectedMessage = "No message available";
        this.showMessagePopup = true;
        return;
      }

      let html = "";

      try {
        // 1. If message is already an object
        if (typeof message === "object") {
          if (message.Html?.Data) {
            html = message.Html.Data;
          } else if (message.Text?.Data) {
            html = message.Text.Data;
          } else {
            html = JSON.stringify(message, null, 2);
          }
        }
        // 2. If message is a string
        else if (typeof message === "string") {
          let parsed = null;
          let trimmedMessage = message.trim();

          if (trimmedMessage.startsWith("{") && trimmedMessage.endsWith("}")) {
            try {
              let jsonString = trimmedMessage
                .replace(/'/g, '"')
                .replace(/None/g, "null")
                .replace(/True/g, "true")
                .replace(/False/g, "false");

              parsed = JSON.parse(jsonString);
            } catch (e) {
              try {
                parsed = new Function(`return ${trimmedMessage}`)();
              } catch (err) {
                parsed = null;
              }
            }
          }

          if (parsed && typeof parsed === "object") {
            if (parsed.Html?.Data) {
              html = parsed.Html.Data;
            } else if (parsed.Text?.Data) {
              html = parsed.Text.Data;
            } else {
              html = JSON.stringify(parsed, null, 2);
            }
          } else {
            html = message;
          }
        }

        html = html
          .replace(/\\n/g, "\n")
          .replace(/\\"/g, '"')
          .replace(/\\'/g, "'")
          .replace(/^\s+/gm, "")
          .trim();

        if (!/<[a-z][\s\S]*>/i.test(html)) {
          // Make URLs clickable
          html = html.replace(
            /(https?:\/\/[^\s]+)/g,
            '<a href="$1" target="_blank" style="color:#2563eb;text-decoration:underline;">$1</a>',
          );

          // Preserve line breaks
          html = html.replace(/\n/g, "<br><br>");

          html = `
    <div style="
      white-space: normal;
      font-family: Arial, sans-serif;
      font-size: 14px;
      line-height: 1.8;
      text-align: left;
      padding: 10px;
    ">
      ${html}
    </div>
  `;
        } else {
          html = html.replace(
            /<pre[^>]*>/i,
            '<pre style="white-space: pre-wrap;font-family:Arial,sans-serif;font-size:14px;line-height:1.8;text-align:left;padding:10px;">',
          );
        }
        this.selectedMessage = html;
        this.showMessagePopup = true;
      } catch (error) {
        console.error("Message parsing error:", error);
        this.selectedMessage = message;
        this.showMessagePopup = true;
      }
    },
    closeMessagePopup() {
      this.showMessagePopup = false;
      this.selectedMessage = "";
    },
    async userdeownload() {
      if (this.isDownload) return;

      this.isDownload = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/email-history/export/?Key=${this.userInfo.token_key}`,
          {
            user_ids: this.userSelectList,
            semester: this.selectfilter,
            program: this.selectProgramfilter,
            batch: this.selectedBatchId,
          },
        );

        if (response.data.status === 200) {
          this.response_message =
            "Your file is ready to download. Go to the download history page.";

          this.userSelectList = [];

          setTimeout(() => {
            this.response_message = "";
          }, 5000);
        } else {
          this.messages = {
            text: response.data.message || "Download failed",
            type: "error",
          };
        }
      } catch (error) {
        console.error(error);

        this.messages = {
          text:
            error.response?.data?.message ||
            "Something went wrong. Please try again.",
          type: "error",
        };
      } finally {
        this.isDownload = false;

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "",
          };
        }, 2500);
      }
    },
    stripHtml(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getEmail(1);
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.userSelectList = this.allEmaillist.map((x) => x.user.id);
      } else {
        this.userSelectList = [];
      }
    },
    async getAllEmail() {
      let params = {
        Key: this.userInfo.token_key,
      };

      if (this.selectfilter) {
        params.title = this.selectfilter;
      }
      if (this.searching) {
        params.search = this.searching;
      }
      if (this.selected_sort) {
        params.ordering = this.selected_sort;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/email-history-without-pagination/list/`,
          { params },
        );

        if (response.data.status === 200) {
          this.allEmaillist = response.data.data;
          this.total_count = response.data.count;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getEmail(page) {
      this.currentPage = page;

      let params = {
        Key: this.userInfo.token_key,
        page: page,
        page_size: this.pageSize,
      };

      if (this.selectfilter) {
        params.title = this.selectfilter;
      }
      if (this.searching) {
        params.search = this.searching;
      }
      if (this.selected_sort) {
        params.ordering = this.selected_sort;
      }
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/email_history/`,
          { params },
        );

        if (response.data.data.status === 200) {
          this.email_list = response.data.data.data;
          this.totalPages = response.data.total_page;
          this.current_page = response.data.current_page;
          this.total_count = response.data.total;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    clearFilters() {
      this.selectfilter = "";
      this.searching = "";
      this.userSelectList = [];
      this.selectAll = false;
      this.selected_sort = "";
      this.getAllEmail();
      this.getEmail(this.current_page);
    },

    async fetchTemplates() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/model/list/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data) {
            this.templates = response.data;
          } else {
            console.log("got error");
          }
        });
    },

    async fetchSchema() {
      if (!this.selectedId) {
        this.activeSchema = null;
        this.selectedTemplateTitle = "";
        this.form = {};
        return;
      }
      await axios
        .get(
          `${process.env.VUE_APP_API}/form/list/?id=${this.selectedId}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data) {
            this.activeSchema = response.data[0];
            this.selectedTemplateTitle = this.activeSchema.title;
            this.form = {};
            this.activeSchema.fields.forEach((field) => {
              this.form[field.label] = "";
              if (field.type === "ForeignKey") {
                this.fetchForeignKey(field.model);
              }
            });
          } else {
            console.log("got error");
          }
        });
    },
    async fetchForeignKey(model) {
      if (model === "Course") {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/courses/title/?Key=${this.userInfo.token_key}`,
        );

        this.mockOptions.Course = res.data?.data?.map((c) => ({
          id: c.id,
          name: c.course_title,
        }));
      }

      // 🔜 Add more models here later
      if (model === "Assignment") {
        if (!this.selectedCourseId) return;
        const res = await axios.get(
          `${process.env.VUE_APP_API}/Inst_Assignment/view/?course_id=${this.selectedCourseId}&Key=${this.userInfo.token_key}`,
        );

        this.mockOptions.Assignment = res.data?.data?.data?.map((a) => ({
          id: a.id,
          name: a.title,
        }));
      }
      if (model === "CourseQuiz") {
        if (!this.selectedCourseId) return;
        const res = await axios.get(
          `${process.env.VUE_APP_API}/coursequiz/name/list/?course=${this.selectedCourseId}&Key=${this.userInfo.token_key}`,
        );

        this.mockOptions.CourseQuiz = res.data?.map((a) => ({
          id: a.id,
          name: a.name,
        }));
      }
      if (model === "Section") {
        if (!this.selectedCourseId) return;
        const res = await axios.get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.selectedCourseId}&Key=${this.userInfo.token_key}`,
        );

        this.mockOptions.Section = res.data?.data?.map((a) => ({
          id: a.id,
          name: a.title,
        }));
      }
      if (model === "Lesson") {
        if (!this.selectedCourseId || !this.selectedSectionId) return;
        const res = await axios.get(
          `${process.env.VUE_APP_API}/lessons/?course_name=${this.selectedCourseId}&Key=${this.userInfo.token_key}&section_id=${this.selectedSectionId}`,
        );

        const lessons = res.data?.results || res.data?.data || [];

        this.mockOptions.Lesson = lessons.map((a) => ({
          id: a.id,
          name: a.title,
        }));
      }
      if (model === "Calendar") {
        if (!this.selectedCourseId) return;
        const res = await axios.get(
          `${process.env.VUE_APP_API}/calendar/view/?course_data__id=${this.selectedCourseId}&Key=${this.userInfo.token_key}`,
        );

        this.mockOptions.Calendar = res.data?.data?.map((a) => ({
          id: a.id,
          name: a.title,
        }));
      }
      if (model === "Team") {
        if (!this.selectedCourseId) return;
        const res = await axios.get(
          `${process.env.VUE_APP_API}/teams/${this.selectedCourseId}/?Key=${this.userInfo.token_key}`,
        );

        this.mockOptions.Team = res.data?.data?.map((a) => ({
          id: a.id,
          name: a.title,
        }));
      }
      if (model === "Project") {
        if (!this.selectedTeamId) return;
        const res = await axios.get(
          `${process.env.VUE_APP_API}/projects/${this.selectedTeamId}/?Key=${this.userInfo.token_key}`,
        );

        this.mockOptions.Project = res.data?.data?.map((a) => ({
          id: a.id,
          name: a.title,
        }));
      }
    },

    getOptions(model) {
      return this.mockOptions[model] || [];
    },

    submit() {
      this.disable_submit = true;
      const payload = {
        title: this.selectedTemplateTitle,
      };

      // build payload from dynamic form
      Object.keys(this.form).forEach((key) => {
        if (key === "Email") {
          payload["Email"] = this.form[key]
            .split(",")
            .map((email) => email.trim());
        } else {
          payload[key] = this.form[key];
        }
      });

      axios
        .post(
          `${process.env.VUE_APP_API}/bulk_email/sending/?Key=${this.userInfo.token_key}`,
          payload,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.disable_submit = false;
              this.showPopup = false;
              this.form = {};
              this.selectedId = "";
              this.activeSchema = null;
              this.getEmail(1);
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.disable_submit = false;
            }, 2000);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
